import DownloadList from "../../components/Lists/DownloadList"
import reportsPageData from "../../data/english/subpages/reports-page-data"
import Footer from "../../layouts/Footer"
import MainHeader from "../../layouts/MainHeader"

const ReportsPage = () => {
  return (
    <main id="main" className="page">
      <div className="sticky-view-two">
        <div className="sticky-container">
          <MainHeader
            title=""
            image={{
              src: require(`../../assets/images/wallpaper/${reportsPageData.header.image.src}`),
              alt: reportsPageData.header.image.alt,
            }}
          />
        </div>
        <div className="sticky-container-two">
          <div className="wrapper-small">
            <h1 className="title-center">{reportsPageData.title}</h1>
            <p className="text-parargraph">{reportsPageData.paragraphOne}</p>
          </div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="wrapper-small">
            <DownloadList data={[
               {
                name: "2023 SAB UN Disclosures - English (PDF)",
                path: './SAB 2023 UN PRP Disclosures.pdf'
              },
              {
                name: "2023 SAB ESG Report - Arabic (PDF)",
                path: './2023 SAB ESG Report - Arabic.pdf'
              },
              {
                name: "2023 SAB ESG Report - English (PDF)",
                path: './2023 SAB ESG Report - English.pdf'
              },
              {
                name: "2023 Limited Assurance Report - Arabic (PDF)",
                path: "./2023 Limited Assurance Report - Arabic.pdf"
              },
              {
                name: "2023 Limited Assurance Report - English (PDF)",
                path: "./2023 Limited Assurance Report - English.pdf"
              },
              {
                name: "2023 Reporting Criteria - Arabic (PDF)",
                path: "./2023 Reporting Criteria - Arabic.pdf"
              },
              {
                name: "2023 Reporting Criteria - English (PDF)",
                path: "./2023 Reporting Criteria - English.pdf"
              },
              {
                name: "Sample - Transition Engagement Questionnaire (TEQ) (PDF)",
                path: "./Sample - Transition Engagement Questionnaire (TEQ).pdf"
              },
              {
                name: "Sustainable Finance & Investments - Data dictionary (PDF)",
                path: "./Sustainable Finance  Investments - Data dictionary.pdf"
              },

              {
                name: "SAB 2022 ESG Report - Arabic (PDF)",
                path: "./SAB_2022_ESG_report_Arabic_200623.pdf"
              },
              {
                name: "SAB 2022 ESG Report - English (PDF)",
                path: "./SAB_2022_ESG_report_200623.pdf"
              },
              {
                name: "Independent Assurance Report - English (PDF)",
                path: "./Independent Assurance Report English.pdf"
              },
              {
                name: "Independent Assurance Report - Arabic (PDF)",
                path: "./Independent Assurance Report Arabic.pdf",
              },
              {
                name: "SAB Sustainable Debt Framework (PDF)",
                path: "./SAB_Sustainable_Debt Framework.pdf"
              },
              {
                name: "SAB Sustainable Debt Framework - Second Party Opinion (PDF)",
                path: "./SAB_Sustainable_Debt Framework_Second_Party_Opinion.pdf"
              }
            ]} />
          </div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  )
}

export default ReportsPage